import React from "react";
import { Dropdown, Option } from "@fluentui/react-components";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";

function QueueSelectorComponent({ QUEUES, displayName, getData, disabled }) {
  const { t } = useTranslation();
  const queuesArray = Object.values(QUEUES || {});

  return (
    <Dropdown
     className="chatflow-textArea-greeting"
      placeholder={t("SELECT_QUEUE")}
      value={displayName || ""}
      disabled={disabled}
      onOptionSelect={(_, data) => {
        const selectedQueue = queuesArray.find(q => q.id === data.optionValue);
        if (selectedQueue && getData) {
          getData({
            id: selectedQueue.id,
            displayName: selectedQueue.queueName || selectedQueue.displayName,
            type: "queue", // <-- always keep type as "queue"
          });
        }
      }}
    >
      {queuesArray.map(queue => (
        <Option key={queue.id} value={queue.id}>
          {queue.queueName || queue.displayName || queue.id}
        </Option>
      ))}
    </Dropdown>
  );
}

const mapStateToProps = state => ({
  QUEUES: state.reducer.QUEUES,
});

export default connect(mapStateToProps)(QueueSelectorComponent);
